module.exports = __webpack_public_path__ + "static/media/armoire.4788ad3c.svg";